/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDeliveryMethodDto } from '../../models/api-response-delivery-method-dto';
import { DeliveryMethodDto } from '../../models/delivery-method-dto';

export interface CreateDeliveryMethod$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: DeliveryMethodDto
}

export function createDeliveryMethod(http: HttpClient, rootUrl: string, params: CreateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDeliveryMethodDto>> {
  const rb = new RequestBuilder(rootUrl, createDeliveryMethod.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDeliveryMethodDto>;
    })
  );
}

createDeliveryMethod.PATH = '/v1/api/delivery-methods';
